__turbopack_context__.v({
  "centered": "Modal-module__99DgRG__centered",
  "clickableHeader": "Modal-module__99DgRG__clickableHeader",
  "closeButton": "Modal-module__99DgRG__closeButton",
  "header": "Modal-module__99DgRG__header",
  "modal": "Modal-module__99DgRG__modal",
  "modalBody": "Modal-module__99DgRG__modalBody",
  "modalFooter": "Modal-module__99DgRG__modalFooter",
  "screenWrapper": "Modal-module__99DgRG__screenWrapper",
  "title": "Modal-module__99DgRG__title",
});
